import { createFileRoute } from '@tanstack/react-router';
import { ForgotPasswordForm } from '@onesource/components';
import { AuthLayout } from 'src/layouts/auth';

export const Route = createFileRoute('/auth/forgot-password')({
  component: () => (
    <AuthLayout>
      <ForgotPasswordForm />
    </AuthLayout>
  ),
});
